module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 18-070a930e4c9b43d46d97c35df738c45a.webp";